<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol
                    ><h1 class="page__title">
                        {{ $t(titlePage) }}
                    </h1></CCol
                >
                <CCol>
                    <ButtonCreate
                        :title="$t('create_form')"
                        @click="
                            $router.push({
                                name: 'view_forms',
                            })
                        "
                    >
                        {{ $t("create_form") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 mb-4">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.forms.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CCardHeader
                    v-show="
                        hasItemsInTable({
                            tableName: 'forms',
                        })
                    "
                >
                    <div class="d-flex">
                        <TableSettings
                            :allFields="tables.forms.allFields"
                            :activeFields.sync="tables.forms.fields"
                        />
                    </div>
                </CCardHeader>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'forms',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardBody>
                                <CCTable
                                    size="sm"
                                    :items="tables.forms.items"
                                    :fields="tables.forms.fields"
                                    :columnFilterValue.sync="
                                        tables.forms.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.forms.rows"
                                    v-bind="tables.forms"
                                    :resizable="false"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.forms
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'view_forms',
                                                                query: {
                                                                    type: 'edit',
                                                                    uuid: tables
                                                                        .forms
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("edit_form")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        v-if="
                                                            tables.forms
                                                                .itemSelected &&
                                                            stringToBoolean(
                                                                tables.forms
                                                                    .itemSelected
                                                                    .isTemplateStep
                                                            ) == false
                                                        "
                                                        @click="
                                                            downloadForm(
                                                                tables.forms
                                                                    .itemSelected
                                                                    .uuid
                                                            )
                                                        "
                                                    >
                                                        {{ $t("download") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        v-else
                                                        tag="div"
                                                        @click="
                                                            $router.push({
                                                                name: 'steps',
                                                                query: {
                                                                    form_id:
                                                                        tables
                                                                            .forms
                                                                            .itemSelected
                                                                            .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{ $t("download") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            buildPreview({
                                                                uuid: tables
                                                                    .forms
                                                                    .itemSelected
                                                                    .uuid,
                                                            })
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("preview")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #_selected="{ item }">
                                        <CInputRadio
                                            :checked="
                                                item ===
                                                tables.forms.itemSelected
                                            "
                                            @update:checked="
                                                selectItemTable('forms', item)
                                            "
                                        />
                                    </template>
                                    <template #provider_name="{ item }">
                                        <RouterLink
                                            :to="
                                                applyQueryToRoute({
                                                    route: '/app/campaings',
                                                    query: { where: {
                                                        id:{
                                                            equal: item.provider_id
                                                        }
                                                    } },
                                                })
                                            "
                                            >{{ item.provider_name }}</RouterLink
                                        >
                                    </template>
                                    <template #final_url="{ item }">
                                        <a
                                            target="_black"
                                            :href="item.final_url"
                                            >{{ item.final_url }}</a
                                        >
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/forms.api"
                                                :table="tables.forms"
                                            />
                                        </div>
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter v-show="tables.forms.items.length > 0">
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.forms.page"
                                        :pages="tables.forms.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.forms.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                class="mb-4"
                v-show="
                    !hasItemsInTable({
                        tableName: 'forms',
                    })
                "
            >
                <template #title> Create you first Form </template>
                <template #description>
                    {{ $t("first_item.form.description") }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        :title="$t('create_form')"
                        @click="
                            $router.push({
                                name: 'view_forms',
                            })
                        "
                    >
                        {{ $t("create_form") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button m-2"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'forms',
                            })
                        "
                        @click="cleanFiltersAdvance('forms'), updateData()"
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean Filter") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import CCTable from "~/components/CCTable";
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import ButtonCreate from "~/components/ButtonCreate";

import axios from "axios";
import NoItemsContainer from "~/components/NoItemsContainer";
import {
    cilPlus,
    cilSettings,
    cilSpreadsheet,
    cilPencil,
    cilDataTransferDown,
    cilArrowThickFromRight,
    cilMediaPlay,
    cilWarning,
    cilChart,
} from "@coreui/icons";
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import TableSettings from "£lement/TableSettings";
/** Icons */
import { eraser } from "~/assets/icons/js/eraser";

export default {
    name: "FormsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        FilterFields,
        ButtonCreate,
        ButtonExport,
        NoItemsContainer,
        TableSettings,
        CCTable,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilDataTransferDown,
        cilArrowThickFromRight,
        cilMediaPlay,
        cilWarning,
        cilChart,
        cilSpreadsheet,
        eraser,
    },

    data() {
        return {
            tables: {
                forms: {
                    fields: [
                        {
                            key: "_selected",
                            label: "",
                            sortable: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "id",
                            label: "#",
                            sortable: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "name",
                            label: "Name",
                            sorter: true,
                            filter: true,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "language_id",
                            label: "Language",
                            sorter: true,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "provider_name",
                            label: "Campaign",
                            sorter: true,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "final_url",
                            label: "Final Url",
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "form_version",
                            label: "Version",
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "api_key",
                            label: "Api Key",
                            filter: false,
                            _filter: {
                                active: false,
                                value: null,
                                condition: "is_equal_to"
                            },
                            active: false,
                            _active: false,
                        },
                        {
                            key: "created_at",
                            label: "Created At",
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                    ],
                    allFields: [],
                    items: [],
                    order: "desc",
                    page: 1,
                    rows: 10,
                    total_pages: 1,
                    loading: true,
                    pagination: true,
                    sorter: true,
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    itemSelected: null,
                },
            },
            url: null,
            html: null,
            src: null,
            loading: false,
        };
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "forms",
                url: "/forms.api",
            });
            this.tables.forms.itemSelected = null;
            this.loadLanguageInTable({
                tableName: "forms",
                fielLanguageName: "language_id",
            });
            this.loadCountryInTable({
                tableName: "forms",
                fielCountryName: "country_id",
            });

            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
        base64Decode(str) {
            return decodeURIComponent(escape(window.atob(str)));
        },
        getBlobURL(code, type) {
            const blob = new Blob([code], { type });
            return URL.createObjectURL(blob);
        },
        async buildPreview({ uuid }) {
            try {
                const { data } = await axios.get(
                    "/form.api/" + uuid + "/deploy"
                );
                if (data.success) {
                    let a = document.createElement("a");
                    let findIndex = data.pages.findIndex((url) => {
                        return url.includes("index");
                    });
                    a.setAttribute("href", data.pages[findIndex]);
                    a.setAttribute("target", "_blank");
                    a.click();
                }
            } catch (error) {
                this.showMessageError(error);
            }
        },
        async downloadForm(form_uuid) {
            try {
                /* Build URL */
                let { landing_page } = await this.loadData({
                    url: "/forms.api/" + form_uuid + "/template",
                    method: "GET",
                });
                let url_form = this.base64Decode(landing_page);
                const link = document.createElement("a");
                link.href = url_form;
                link.download = "index.html"; //or any other extension
                link.click();
            } catch (error) {
                this.showMessageError(error);
            }
        },
    },
    mounted() {
        this.updateData();
    },
    created() {
        this.loadLanguages();
        this.loadCountries();
    },
};
</script>

<style scoped lang="scss"></style>
